// @ts-nocheck
// ========================================
// 固定デッキ定義
// ========================================

/**
 * 固定デッキのリスト
 * cards: カードIDの配列（40枚）
 * 同じカードは最大3枚まで（禁忌カードは1枚まで）
 */
export const PREBUILT_DECKS = {
  random: {
    id: 'random',
    name: 'ランダム',
    description: 'カードプールからランダムに構築',
    cards: null, // nullの場合はランダム生成
  },

  starter: {
    id: 'starter',
    name: '紅蓮の咆哮',
    description: '【スターターデッキ】炎ドラゴン入門。シンプルなシナジーを学べる初心者向け',
    cards: [
      // ================================================================================
      // モンスター（26枚）
      // ================================================================================

      // 【コスト1】バニラ・サーチ役（6枚）
      'C0000292', 'C0000292', 'C0000292', // 炎のソルジャー x3 ATK500/HP500 【効果なし】
      'C0000163', 'C0000163', 'C0000163', // 岩狸・石ころ丸 x3 ATK400/HP400 ★サーチ

      // 【コスト2】低コストアタッカー（11枚）
      'C0000293', 'C0000293', 'C0000293', // 炎のソルジャーII x3 ATK900/HP1000 【効果なし】
      'C0000025', 'C0000025', 'C0000025', // ブレイズ・ドラゴン x3 ATK1200/HP1200 ★破壊時サーチ
      'C0000305', 'C0000305', 'C0000305', // フレア・リザード x3 ATK500/HP500 【変幻身】
      'C0000164', 'C0000164',             // 岩狸・岩太 x2 ATK800/HP1000 ★自壊時200ダメージ

      // 【コスト3】主力モンスター（6枚）
      'C0000021', 'C0000021',             // フレア・ドラゴン x2 ATK1800/HP1500 ★召喚時300バーン
      'C0000029', 'C0000029',             // クリムゾン・ワイバーン x2 ATK1400/HP1400 ★ドラゴン時ATK+400
      'C0000026', 'C0000026',             // インフェルノ・ドラゴン x2 ATK1600/HP1800 ★攻撃時ATK-300

      // 【コスト4】中堅モンスター（3枚）
      'C0000027', 'C0000027',             // マグマ・ドラゴン x2 ATK2000/HP2400 ★魔法使用時200ダメージ
      'C0000030',                          // バースト・ドラゴン・ナイト x1 ATK1800/HP2000 ★ドラゴン撃破で追加攻撃

      // ================================================================================
      // 魔法（11枚）
      // ================================================================================

      // 【コスト1】軽量魔法（2枚）
      'C0000033', 'C0000033',             // 紅蓮の覚醒 x2 ★ドラゴン覚醒+ATK700

      // 【コスト2】基本魔法（5枚）
      'C0000031', 'C0000031',             // 炎の咆哮 x2 ★ドラゴンATK+500 + 300ダメージ
      'C0000022', 'C0000022', 'C0000022', // 火竜の吐息 x3 ★1000ダメージ【刹那詠唱】

      // 【コスト3】中堅魔法（4枚）
      'C0000034', 'C0000034',             // 炎の嵐 x2 ★ドラゴン数×200ダメージ
      'C0000032', 'C0000032',             // ドラゴンの炎息 x2 ★800+全体300【刹那詠唱】

      // ================================================================================
      // フィールド（3枚）
      // ================================================================================
      'C0000037', 'C0000037',             // ドラゴンの火山 x2 ★ドラゴンATK+400 + 毎ターン300ダメージ
      'C0000187',                          // 狸の熔岩郷 x1 ★毎ターン岩狸蘇生 + 300回復
    ],
  },

  fire: {
    id: 'fire',
    name: '紅蓮龍炎',
    description: '炎ドラゴンアグロ。圧倒的なコスト効率とバーンダメージで4〜6ターンで削り切る超攻撃型',
    cards: [
      // ================================================================================
      // モンスター（24枚）
      // ================================================================================

      // 【コスト2】（6枚）
      'C0000025', 'C0000025', 'C0000025', // ブレイズ・ドラゴン x3 ATK1200/HP1200 【ドラゴン】
      'C0000369', 'C0000369', 'C0000369', // 炎翼の鳥民・イグニス x3 ATK1200/HP1100 【ヒューマノイド】

      // 【コスト3】（9枚）
      'C0000021', 'C0000021', 'C0000021', // フレア・ドラゴン x3 ATK1800/HP1500 【ドラゴン】★主力
      'C0000026', 'C0000026', 'C0000026', // インフェルノ・ドラゴン x3 ATK1600/HP1800 【ドラゴン】
      'C0000029', 'C0000029', 'C0000029', // クリムゾン・ワイバーン x3 ATK1400/HP1400 【ワイバーン】

      // 【コスト4】（5枚）
      'C0000027', 'C0000027', // マグマ・ドラゴン x2 ATK2000/HP2400 【ドラゴン】
      'C0000030', 'C0000030', // バースト・ドラゴン・ナイト x2 ATK1800/HP2000 【ドラゴン】
      'C0000312', // フレア・ワイバーン x1 ATK1800/HP2000 【ワイバーン】

      // 【コスト5】（2枚）
      'C0000023', 'C0000023', // レッドバーストドラゴン x2 ATK2500/HP2700 【ドラゴン】★エース

      // 【コスト6】（2枚）
      'C0000028', 'C0000028', // 炎竜母フレイマ x2 ATK2500/HP3000 【ドラゴン】★フィニッシャー

      // ================================================================================
      // 魔法（14枚）
      // ================================================================================

      // 【コスト1】（2枚）
      'C0000033', 'C0000033', // 紅蓮の覚醒 x2

      // 【コスト2】（6枚）
      'C0000022', 'C0000022', 'C0000022', // 火竜の吐息 x3 【刹那詠唱】★最強魔法
      'C0000031', 'C0000031', 'C0000031', // 炎の咆哮 x3

      // 【コスト3】（4枚）
      'C0000032', 'C0000032', // ドラゴンの炎息 x2 【刹那詠唱】
      'C0000034', 'C0000034', // 炎の嵐 x2

      // 【コスト4】（2枚）
      'C0000036', 'C0000036', // 燃え尽きる業火 x2

      // ================================================================================
      // フィールド（2枚）
      // ================================================================================
      'C0000037', 'C0000037', // ドラゴンの火山 x2 ★継続ダメージ
    ],
  },

  water: {
    id: 'water',
    name: '深海デッキ',
    description: '水属性のコントロール型。凍結と回復で戦場を支配',
    cards: [
      // 低コストモンスター (10枚)
      'C0000042', 'C0000042', 'C0000042', // 潮の乙女 x3
      'C0000046', 'C0000046', 'C0000046', // 泡沫の精霊 x3
      'C0000143', 'C0000143', // 氷猫の使い魔 x2
      'C0000144', 'C0000144', // ブリザードキャット・フロスト x2

      // 中コストモンスター (10枚)
      'C0000039', 'C0000039', 'C0000039', // アクア・メイデン x3
      'C0000044', 'C0000044', // 水晶のマーメイド x2
      'C0000045', 'C0000045', // 海流の守護者 x2
      'C0000145', 'C0000145', // ブリザードキャット・スノウ x2
      'C0000142', // ブリザードマスター x1

      // 高コストモンスター (5枚)
      'C0000040', 'C0000040', // シー・サーペント x2
      'C0000043', 'C0000043', // 深海のクラーケン x2
      'C0000041', // ダーク・リヴァイアサン（禁忌）x1

      // 魔法カード (12枚)
      'C0000047', 'C0000047', // マーメイドの恵み x2
      'C0000049', 'C0000049', 'C0000049', // タイダルシフト x3
      'C0000050', 'C0000050', // クラーケンの呼び声 x2
      'C0000051', 'C0000051', // リヴァイアサンの奔流 x2
      'C0000150', 'C0000150', // 氷の吐息 x2
      'C0000151', // ブリザードの呼び声 x1

      // フィールドカード (3枚)
      'C0000053', 'C0000053', // 母なる大海 x2
      'C0000054', // 珊瑚の迷宮 x1
    ],
  },

  light: {
    id: 'light',
    name: '聖光デッキ',
    description: '光属性の回復・バフ型。持久戦で有利を取る',
    cards: [
      // 低コストモンスター (10枚)
      'C0000062', 'C0000062', 'C0000062', // 光の使徒 x3
      'C0000059', 'C0000059', 'C0000059', // 光の騎士 x3
      'C0000020', 'C0000020', // 灯火の護衛霊 x2
      'C0000121', 'C0000121', // 聖域の灯守兵 x2

      // 中コストモンスター (10枚)
      'C0000057', 'C0000057', 'C0000057', // プリズム・ガーディアン x3
      'C0000060', 'C0000060', // 聖なる導師 x2
      'C0000056', 'C0000056', // 輝聖女ルミナス x2
      'C0000061', 'C0000061', // 輝くユニコーン x2
      'C0000122', // 聖域の戦士 x1

      // 高コストモンスター (5枚)
      'C0000058', 'C0000058', // 熾天使セラフ x2
      'C0000063', 'C0000063', // 聖獣フェニックス x2
      'C0000162', // 死神天使ルシフェリエル（禁忌）x1

      // 魔法カード (12枚)
      'C0000065', 'C0000065', 'C0000065', // 天使の波動 x3
      'C0000066', 'C0000066', // ホーリーライトサモン x2
      'C0000068', 'C0000068', // クリスタルブレス x2
      'C0000064', 'C0000064', // ルミナスの裁き x2
      'C0000158', 'C0000158', // 聖光の刃 x2
      'C0000070', // 支配光の連鎖 x1

      // フィールドカード (3枚)
      'C0000071', 'C0000071', // クリスタルサンクチュアリ x2
      'C0000072', // ルミナスの聖域 x1
    ],
  },

  balanced: {
    id: 'balanced',
    name: 'バランスデッキ',
    description: '開発テスト用。複数属性の代表的なカードを収録',
    cards: [
      // 炎属性 (10枚)
      'C0000021', 'C0000021', // フレア・ドラゴン x2
      'C0000025', 'C0000025', // ブレイズ・ドラゴン x2
      'C0000026', 'C0000026', // インフェルノ・ドラゴン x2
      'C0000022', 'C0000022', // 火竜の吐息 x2
      'C0000037', 'C0000037', // ドラゴンの火山 x2

      // 水属性 (10枚)
      'C0000039', 'C0000039', // アクア・メイデン x2
      'C0000042', 'C0000042', // 潮の乙女 x2
      'C0000043', 'C0000043', // 深海のクラーケン x2
      'C0000049', 'C0000049', // タイダルシフト x2
      'C0000053', 'C0000053', // 母なる大海 x2

      // 光属性 (10枚)
      'C0000059', 'C0000059', // 光の騎士 x2
      'C0000057', 'C0000057', // プリズム・ガーディアン x2
      'C0000060', 'C0000060', // 聖なる導師 x2
      'C0000065', 'C0000065', // 天使の波動 x2
      'C0000071', 'C0000071', // クリスタルサンクチュアリ x2

      // 原始属性 (10枚)
      'C0000001', 'C0000001', 'C0000001', // 粘液獣・開花 x3
      'C0000002', 'C0000002', // 触覚持ち粘液獣 x2
      'C0000004', 'C0000004', // ゴミあさり粘液獣 x2
      'C0000003', 'C0000003', // 粘液獣の群生地 x2
      'C0000003', // 粘液獣の群生地 x1 (追加で計3枚)
    ],
  },

  eclasia: {
    id: 'eclasia',
    name: '星灯のエクラシア',
    description: '未来属性コンボデッキ。エクラシアの時空炉を段階強化し、黄金の時姫でフィニッシュ',
    cards: [
      // ================================================================================
      // モンスター（24枚）
      // ================================================================================

      // 【コスト1】（3枚）
      'C0000085', 'C0000085', // 胡乱なドローン x2 ATK300/HP500
      'C0000090', // 時脈の観測者 x1 ATK400/HP600

      // 【コスト2】（6枚）
      'C0000278', 'C0000278', 'C0000278', // 灯守りの少女 x3 ATK800/HP1200 【エクラシア】
      'C0000116', 'C0000116', // 時空旅人ソラリア x2 ATK700/HP1000
      'C0000105', // 魔導炉の残骸獣 x1 ATK800/HP1000

      // 【コスト3】（6枚）
      'C0000280', 'C0000280', 'C0000280', // 星灯の少女エクラリア x3 ATK1400/HP1800 【エクラシア】★キーカード
      'C0000106', 'C0000106', // 次元渡り・ヴォイドウォーカー x2 ATK1200/HP1500
      'C0000256', // 紫時空の幻鴉 x1 ATK1100/HP1300

      // 【コスト4】（5枚）
      'C0000274', 'C0000274', // 星辰の魔導術師 x2 ATK1600/HP2200 【エクラシア】
      'C0000268', 'C0000268', // 虚蝕の魔導兵 x2 ATK1800/HP2000
      'C0000260', // 預言者モナビン x1 ATK1800/HP2000

      // 【コスト5以上】（4枚）
      'C0000267', 'C0000267', // 星翼の飛舟エクラオン x2 ATK2300/HP2500 【エクラシア】
      'C0000271', 'C0000271', // 黄金の時姫エクラリア x2 ATK2800/HP3200 【エクラシア】★フィニッシャー

      // ================================================================================
      // 魔法（12枚）
      // ================================================================================

      // 【コスト2】（6枚）
      'C0000277', 'C0000277', 'C0000277', // 星屑の時導術 x3 【刹那詠唱】【エクラシア】
      'C0000255', 'C0000255', 'C0000255', // 未来の鴉予言 x3

      // 【コスト3】（4枚）
      'C0000273', 'C0000273', // エクラリアの残影 x2 【エクラシア】
      'C0000269', 'C0000269', // 永遠の灯の残響 x2 【エクラシア】

      // 【コスト4】（2枚）
      'C0000261', // アクセラレート x1
      'C0000262', // 時の遅延 x1

      // ================================================================================
      // フィールド（1枚）
      // ================================================================================
      'C0000257', // 時読みの塔 x1

      // ================================================================================
      // フェイズカード（3枚）
      // ================================================================================
      'C0000266', 'C0000266', 'C0000266', // エクラシアの時空炉 x3 【エクラシア】★コアカード
    ],
  },

  iceControl: {
    id: 'iceControl',
    name: '氷眠の檻',
    description: '水・凍結/眠りコントロール。状態異常で相手を完全に封じ込め、じわじわと削る上級者向けデッキ',
    cards: [
      // ================================================================================
      // モンスター（22枚）
      // ================================================================================

      // 【コスト1】（3枚）
      'C0000046', 'C0000046', // 泡沫の精霊 x2 ATK200/HP300
      'C0000143', // 氷猫の使い魔 x1 ATK400/HP500

      // 【コスト2】（5枚）
      'C0000144', 'C0000144', 'C0000144', // ブリザードキャット・フロスト x3 ATK800/HP1000 ★凍結
      'C0000042', 'C0000042', // 潮の乙女 x2 ATK600/HP1000

      // 【コスト3】（7枚）
      'C0000145', 'C0000145', 'C0000145', // ブリザードキャット・スノウ x3 ATK1200/HP1500 ★凍結
      'C0000039', 'C0000039', 'C0000039', // アクア・メイデン x3 ATK1300/HP1700 ★眠り
      'C0000148', // 氷の双尾猫 x1 ATK1400/HP1800

      // 【コスト4】（4枚）
      'C0000142', 'C0000142', // ブリザードマスター x2 ATK1800/HP2400 ★サーチ
      'C0000146', 'C0000146', // 氷結の守護猫 x2 ATK1600/HP2500

      // 【コスト5】（2枚）
      'C0000147', 'C0000147', // ブリザードキャット・シャード x2 ATK2000/HP2600

      // 【コスト7】（1枚）
      'C0000157', // ブリザードキャット・エターナル x1 ATK3000/HP4800 ★全体凍結【禁忌】

      // ================================================================================
      // 魔法（14枚）
      // ================================================================================

      // 【コスト2・刹那詠唱】（6枚）
      'C0000150', 'C0000150', 'C0000150', // 氷の吐息 x3【刹那詠唱】★ATK-800+凍結
      'C0000288', 'C0000288', 'C0000288', // 酸の霧 x3【刹那詠唱】★ATK0

      // 【コスト3】（5枚）
      'C0000344', 'C0000344', // シスラゴンの汚染 x2 ★ATK-1000+行動不能
      'C0000402', 'C0000402', // 呪術狩りの封印鎖 x2【刹那詠唱】★行動不能
      'C0000151', // ブリザードの呼び声 x1

      // 【コスト4】（2枚）
      'C0000051', 'C0000051', // リヴァイアサンの奔流 x2 ★水モンスター数×400全体ダメ

      // 【コスト5】（1枚）
      'C0000154', // ブリザードの覚醒 x1 ★攻撃力2倍+2回攻撃

      // ================================================================================
      // フィールド（4枚）
      // ================================================================================
      'C0000053', 'C0000053', // 母なる大海 x2 ★凍結バーン+SP回復
      'C0000155', 'C0000155', // 氷猫の聖域 x2 ★ブリザードキャットATK+400
    ],
  },

  elizavette: {
    id: 'elizavette',
    name: '黒呪の魔女エリザヴェット',
    description: 'エリザヴェット・ヴェイルと黒呪魔法のコスト軽減で相手を蝕むコントロールデッキ。呪骸王の500バーンで削り切る',
    cards: [
      // ================================================================================
      // モンスター（18枚）
      // ================================================================================

      // 【コスト2】（6枚）
      'C0000385', 'C0000385', 'C0000385', // 呪魂の従者 x3 ATK800/HP1200 【ソウルカース】
      'C0000427', 'C0000427', 'C0000427', // 灰塵の骨霊ファントマリス x3 ATK800/HP1100 【ソウルカース】

      // 【コスト3】（3枚）
      'C0000407', 'C0000407', 'C0000407', // 魂喰いのレイスヴィット x3 ATK1200/HP1800 【ソウルカース】

      // 【コスト4】（4枚）
      'C0000384', 'C0000384', 'C0000384', // 魔女エリザヴェット・ヴェイル x3 ATK1600/HP2200 ★キーカード
      'C0000418', // 深層の隠蟲クリプトノムス x1 ATK1600/HP2200 【ソウルカース】

      // 【コスト5】（2枚）
      'C0000424', 'C0000424', // 呪灰の翼ダスクドラゴン x2 ATK2200/HP2900 【ソウルカース】

      // 【コスト6】（3枚）
      'C0000396', 'C0000396', // 呪骸王エリザルヴェドン x2 ATK1800/HP4000 ★フィニッシャー
      'C0000425', // 灰骨竜フレアスケルス x1 ATK2600/HP3400 【ソウルカース】

      // ================================================================================
      // 魔法（18枚）
      // ================================================================================

      // 【黒呪魔法・低コスト】（9枚）
      'C0000388', 'C0000388', 'C0000388', // 黒呪・ファルザノンの影爪 x3 【刹那詠唱】
      'C0000389', 'C0000389', 'C0000389', // 黒呪・ザルガノートの呪鎖 x3 【刹那詠唱】
      'C0000390', 'C0000390', 'C0000390', // 黒呪・ヴェルザクトの黒刃 x3 【刹那詠唱】

      // 【黒呪魔法・中コスト】（6枚）
      'C0000391', 'C0000391', // 黒呪・トゥルヴァントの障壁 x2 【刹那詠唱】
      'C0000392', 'C0000392', // 黒呪・ドルヴァネクの傀儡糸 x2
      'C0000393', 'C0000393', // 黒呪・カルヴェリオンの灰嵐 x2

      // 【黒呪魔法・高コスト】（2枚）
      'C0000394', 'C0000394', // 黒呪・エルザフィールの契約 x2

      // 【汎用魔法】（1枚）
      'C0000075', // シャドウ・バインド x1 【刹那詠唱】

      // ================================================================================
      // フィールド（2枚）
      // ================================================================================
      'C0000386', 'C0000386', // 呪縛の塔・ヴェルナクール x2 ★コアカード

      // ================================================================================
      // フェイズカード（2枚）
      // ================================================================================
      'C0000387', 'C0000387', // 呪核の杖・ザルヴェリオ x2
    ],
  },

  slimeSwarm: {
    id: 'slimeSwarm',
    name: '無限増殖',
    description: '粘液獣スウォーム。分裂・増殖で大量展開し、粘液獣・キングの「1体につきATK+1500」で超火力フィニッシャーを作る',
    cards: [
      // ================================================================================
      // モンスター（24枚）
      // ================================================================================

      // 【コスト1】（3枚）
      'C0000008', 'C0000008', 'C0000008', // 粘液獣・胞子 x3 ATK200/HP250 ★サーチ

      // 【コスト2】（9枚）
      'C0000001', 'C0000001', 'C0000001', // 粘液獣・開花 x3 ATK200/HP300 ★★分裂の核
      'C0000009', 'C0000009', 'C0000009', // 粘液獣・寄生 x3 ATK400/HP500
      'C0000304', 'C0000304', 'C0000304', // 粘液獣・幼体 x3 ATK100/HP100 【変幻身】

      // 【コスト3】（4枚）
      'C0000004', 'C0000004', 'C0000004', // ゴミあさり粘液獣 x3 ATK500/HP600 ★墓地蘇生
      'C0000002', // 触覚持ち粘液獣 x1 ATK500/HP650 【魔障壁】

      // 【コスト4】（4枚）
      'C0000005', 'C0000005', // 苗床粘液獣 x2 ATK500/HP650 ★捕食
      'C0000010', 'C0000010', // 粘液獣・融合体 x2 ATK1000/HP1200

      // 【コスト5】（2枚）
      'C0000006', // 新・超覚醒粘液獣ハイパー x1 ATK500/HP600 ★粘液数×ATK+1000
      'C0000011', // 粘液獣・暴走体 x1 ATK1600/HP2000

      // 【コスト6】（2枚）
      'C0000007', 'C0000007', // 粘液獣・キング x2 ATK1000/HP1300 ★★★フィニッシャー

      // ================================================================================
      // 魔法（12枚）
      // ================================================================================

      // 【コスト2】（6枚）
      'C0000012', 'C0000012', 'C0000012', // 粘液の増殖 x3 ★★分裂魔法
      'C0000013', 'C0000013', 'C0000013', // 粘液の罠 x3 【刹那詠唱】★妨害

      // 【コスト3】（4枚）
      'C0000014', 'C0000014', // 粘液再生 x2 ★墓地から2体蘇生
      'C0000015', 'C0000015', // 粘液の浸食 x2 【刹那詠唱】★ATK減少

      // 【コスト4】（2枚）
      'C0000016', 'C0000016', // 粘液爆発 x2 ★全体ダメージ

      // ================================================================================
      // フィールド（4枚）
      // ================================================================================
      'C0000003', 'C0000003', // 粘液獣の群生地 x2 ★★粘液数×300バーン
      'C0000018', 'C0000018', // 粘液の沼地 x2 ★ATK+300
    ],
  },

  gaTraining: {
    id: 'gaTraining',
    name: 'GA訓練用デッキ',
    description: 'GA訓練用の強力なデッキ。多属性の強力モンスターを収録',
    cards: [
      'C0000317', 'C0000419', 'C0000419', 'C0000041', 'C0000327',
      'C0000040', 'C0000327', 'C0000026', 'C0000278', 'C0000311',
      'C0000110', 'C0000419', 'C0000401', 'C0000144', 'C0000327',
      'C0000311', 'C0000040', 'C0000289', 'C0000440', 'C0000317',
      'C0000027', 'C0000027', 'C0000027', 'C0000026', 'C0000128',
      'C0000043', 'C0000026', 'C0000040', 'C0000114', 'C0000401',
      'C0000060', 'C0000311', 'C0000110', 'C0000278', 'C0000320',
      'C0000320', 'C0000320', 'C0000128', 'C0000318', 'C0000110',
    ],
  },

  deepSea: {
    id: 'deepSea',
    name: '深海領域デッキ',
    description: '深海領域システムを活用。潜航・浮上で強力なモンスターを展開',
    cards: [
      // 深海領域モンスター
      'C0000533', 'C0000533', 'C0000533', // x3
      'C0000521', 'C0000521', 'C0000521', // x3
      'C0000522', 'C0000522', 'C0000522', // x3
      'C0000523', 'C0000523', 'C0000523', // x3
      'C0000527', 'C0000527', 'C0000527', // x3
      // 深海領域魔法
      'C0000530', 'C0000530',             // 深度加速 x2
      'C0000532', 'C0000532', 'C0000532', // レヴィアタンの大時化 x3
      'C0000524', 'C0000524',             // x2
      'C0000528',                         // 深海への招き x1
      'C0000526', 'C0000526', 'C0000526', // x3
      // 汎用カード
      'C0000320', 'C0000320',             // x2
      'C0000542', 'C0000542', 'C0000542', // x3
      'C0000040', 'C0000040', 'C0000040', // シー・サーペント x3
      'C0000335', 'C0000335', 'C0000335', // x3
      'C0000334',                         // x1
      'C0000327',                         // x1
      'C0000552',                         // x1
    ],
  },
};

/**
 * デッキIDのリストを取得
 */
export const getDeckIds = () => Object.keys(PREBUILT_DECKS);

/**
 * デッキ情報を取得
 */
export const getDeckInfo = (deckId) => PREBUILT_DECKS[deckId] || null;

/**
 * デッキ選択用のオプションリストを取得
 */
export const getDeckOptions = () => {
  return Object.values(PREBUILT_DECKS).map(deck => ({
    id: deck.id,
    name: deck.name,
    description: deck.description,
  }));
};
